import { connect } from 'react-redux';
import SearchField from './SearchField';
import { fullSearch, instantSearch, updateFilters } from '../../actions/search';

const mapState = (state, props) => ({
  ...props,
  filters: state.search.filters,
});
const mapDispatch = { fullSearch, instantSearch, updateFilters };

export default connect(
  mapState,
  mapDispatch,
)(SearchField);
